module.exports = __webpack_public_path__ + "media/img/Landing_Page/business_meeting_at_home-9df110c2c750495fc0557754333a4cf1.jpg";